import {
  AsignacionConDescuentoResponseSchema,
  CreateAsignacionConDescuentoRequestSchema,
  CreateInventarioAsignacionRequestSchema,
  CreateInventarioRequestSchema,
  DevolverInventarioAsignacionRequestSchema,
  InventarioAsignacionListQuerySchema,
  InventarioAsignacionSchema,
  InventarioListQuerySchema,
  InventarioSchema,
  InventarioSummarySchema,
  UpdateInventarioRequestSchema,
} from '@visep/shared-types/inventario';
import type {
  AsignacionConDescuentoResponse,
  CreateAsignacionConDescuentoRequest,
  DevolverInventarioAsignacionRequest,
  InventarioAsignacion,
  InventarioListQuery,
  InventarioSummary,
} from '@visep/shared-types/inventario';
import type { Helpers } from './internal.js';
import { makeCrudResource, toQuery } from './internal.js';

export function createInventarioResource({ request }: Helpers) {
  const items = makeCrudResource(request, {
    basePath: '/api/inventario',
    schema: InventarioSchema,
    listQuerySchema: InventarioListQuerySchema,
    createSchema: CreateInventarioRequestSchema,
    updateSchema: UpdateInventarioRequestSchema,
  });
  const asignaciones = makeCrudResource(request, {
    basePath: '/api/inventario-asignaciones',
    schema: InventarioAsignacionSchema,
    listQuerySchema: InventarioAsignacionListQuerySchema,
    createSchema: CreateInventarioAsignacionRequestSchema,
    updateSchema: CreateInventarioAsignacionRequestSchema,
  });
  return {
    listItems: items.list,
    getItem: items.get,
    createItem: items.create,
    updateItem: items.update,
    deleteItem: items.delete,
    listAsignaciones: asignaciones.list,
    createAsignacion: asignaciones.create,
    async devolverAsignacion(id: string, input?: DevolverInventarioAsignacionRequest): Promise<InventarioAsignacion> {
      return InventarioAsignacionSchema.parse(
        await request(
          'PATCH',
          `/api/inventario-asignaciones/${encodeURIComponent(id)}/devolucion`,
          DevolverInventarioAsignacionRequestSchema.parse(input ?? {}),
        ),
      );
    },
    deleteAsignacion: asignaciones.delete,
    async createAsignacionConDescuento(input: CreateAsignacionConDescuentoRequest): Promise<AsignacionConDescuentoResponse> {
      return AsignacionConDescuentoResponseSchema.parse(
        await request('POST', '/api/inventario-asignaciones/con-descuento', CreateAsignacionConDescuentoRequestSchema.parse(input)),
      );
    },
    async summary(query?: Partial<InventarioListQuery>): Promise<InventarioSummary> {
      return InventarioSummarySchema.parse(await request('GET', `/api/inventario/summary${toQuery(query ?? {})}`));
    },
  };
}
